import React, { useState, createContext, useContext } from 'react'
import { HubConnectionBuilder } from '@microsoft/signalr';
import { decodeJwtWithJsrs } from "@utils/helpers";
const ADAPTERS_BASE_URL = process.env.REACT_APP_ADAPTERS_BASE_URL;
const INTEGRATORS_BASE_URL = process.env.REACT_APP_API_INTEGRATOR_URL;
interface ApiIntegratorProviderProps {
    children: React.ReactNode
}

export const ApiIntegratorContext = createContext<any>(null);

export const useApiIntegratorHub = () => {
    return useContext(ApiIntegratorContext)
}

export const ApiIntegratorProvider = ({ children }: ApiIntegratorProviderProps) => {
    const [integratorSignalRData, setIntegratorSignalRData] = useState<any>([]);

    const makeIntegratorSignalRConnection = (integratorId: string) => {
        console.log("signalRIntegrator", integratorId); //testing purpose
        const headers = {
            'X-Tenant-Id': localStorage.getItem('domain') as string,
            'X-User-Id': decodeJwtWithJsrs(localStorage.getItem('access_token'))?.sub,
            'X-Application': 'XSI',
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        };

        const connection = new HubConnectionBuilder()
            .withUrl(`${INTEGRATORS_BASE_URL}/xsmpublish?integratorId=${integratorId}`, { headers})
            .withAutomaticReconnect()
            .build();

        connection.start().then(() => {
            connection.invoke('GetConnectionId').then(function (connectionId) {
                console.log("generalConnectionId", connectionId);
            })
        }).then(() => {
            console.log("coming here", connection.connectionId)
            
            connection.on('SendNotification', (integratorId, publishedId, IsSuccess, XSMResponse) => {
                console.log({integratorId, publishedId, IsSuccess, XSMResponse})
                setIntegratorSignalRData((prevItems: any) => [...prevItems, { integratorId, publishedId, XSMResponse, IsSuccess }]);
            })
        })
            .catch(e => console.log('Connection failed: ', e));
    }

    const values = {
        integratorSignalRData,
        makeIntegratorSignalRConnection
    }

    return (
        <ApiIntegratorContext.Provider value={values}>
            {children}
        </ApiIntegratorContext.Provider>
    );
}